module.exports = __webpack_public_path__ + "static/teaser-1-d377968b63ee5b3b326ee97cb48a2d33.jpg";